import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const API_GO = process.env.REACT_APP_API_GO;

export const getApplicationOrderNecessity = async (codes, estates) => {
	const { data } = await axios.get(`${API}/client/application_orders/calculate_necessity`, { params: { codes, estates } });
	return data;
};

export const getApplicationOrderNecessityPDF = async (params) => {
	const { data } = await axios.get(`${API}/client/application_orders/calculate_necessity/pdf`, {
		params: params,
		responseType: "blob",
	});
	return data;
};

export const getLookups = async () => {
	const { data } = await axios.get(`${API_GO}/app/planning/order_application/calculate_necessity/lookups`);
	return data;
};
